export default __webpack_public_path__ + "static/media/6.a58d84cf.svg";